export default __webpack_public_path__ + "static/IMG_6833_rgb-e0b4cc65b6a0ed288c9fac32917eaef7.jpg";